import "./sidebar.css";

export const CORE_CONCEPTS = [
  {
    title: "Car Rental",
    desc1: "Reservations",
    desc2: "Reservation Attempts",
    desc3: "Quotes",
    desc4: "Commissions",
    desc5: "Commission Partner",
    desc6: "Calender",
  },

  {
    title: "Fleet",
    desc1: "Telematics",
    desc2: "Vehicles",
    desc3: "Maintenance",
    desc4: "Repair Orders",
  },
];
